export function stopPropagation(cb: () => any) {
  return (e: Event) => {
    e.stopPropagation()
    cb()
  }
}

export function preventDefault(cb: () => any) {
  return (e: Event) => {
    e.preventDefault()
    cb()
  }
}